import React from "react";
import { Grid, Modal, Box, Typography, TextField, MenuItem } from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import styled from "styled-components";

const TemplateModal = ({
  mailData,
  setMailData,
  templates,
  populate,
  bottomToolbarStates,
  setBottomToolbarStates,
  openModal,
}) => {
  return (
    <Modal
      open={openModal}
      onClose={() => setBottomToolbarStates({ ...bottomToolbarStates, isTemplateModal: false })}
    >
      <StyledBox>
        <StyledGrid container alignItems="center">
          <Grid item>
            <Typography>Templates</Typography>
          </Grid>
          <Grid item style={{ flex: "1" }}></Grid>
          <Grid item>
            <Close
              onClick={() =>
                setBottomToolbarStates({ ...bottomToolbarStates, isTemplateModal: false })
              }
              style={{ color: "white" }}
            />
          </Grid>
        </StyledGrid>
        <Grid container alignItems="center" style={{ padding: "10px 15px" }}>
          <Grid item style={{ marginRight: "24px" }}>
            <Typography color="textSecondary" variant="body1">
              Select Template
            </Typography>
          </Grid>
          <Grid item style={{ flex: "1" }}>
            <TextField
              select
              fullWidth={true}
              variant="standard"
              value={mailData.selectedTemplate}
              onChange={(e) => {
                setMailData({ ...mailData, selectedTemplate: e.target.value });
                populate(e.target.value);
                setBottomToolbarStates({ ...bottomToolbarStates, anchorEl: null });
              }}
            >
              {templates?.map((el) => (
                <MenuItem key={el.id} value={el.id}>{el.name}</MenuItem>
              ))}
              {templates != null && templates.length === 0 && (
                <MenuItem>No Templates Found</MenuItem>
              )}
            </TextField>
          </Grid>
        </Grid>
      </StyledBox>
    </Modal>
  );
};

export default TemplateModal;

const StyledBox = styled(Box)`
  && {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 50%;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0.5px 1px 25px 0.5px rgba(0, 0, 0, 0.3);
    overflow: hidden;
  }
`;
const StyledGrid = styled(Grid)`
  && {
    padding: 10px 10px 10px 10px;
    background-color: #404040;
    color: white;
  }
`;